import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
import useResponsive from "../../hooks/useResponsive";

export const Header = () => {
  const marginTop = 4;
  const navigate = useNavigate();
  const location = useLocation();
  const { isSm, isXs } = useResponsive();

  const isMobile = isSm || isXs;
  const isResultsPage = location.pathname === "/results";

  const handleStartOver = () => {
    navigate("/");
  };

  if (isMobile) return null;

  return (
    <Container>
      <Box py={marginTop}>
        {isMobile ? null : <Breadcrumb />}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography mt={marginTop} fontSize={37}>
            Heat Pump Calculator
          </Typography>
          {isResultsPage && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleStartOver}
            >
              Start Over
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};
